import {Action, createReducer, on} from '@ngrx/store';
import * as OrdersActions from './orders.actions';
import {createEntityAdapter, EntityState} from '@ngrx/entity';

export const ordersFeatureKey = 'orders';
export const orderAdapter = createEntityAdapter<Order>();

export interface OrdersState extends EntityState<Order> {
  loaded: boolean;
}

export const ordersInitialState: OrdersState = orderAdapter.getInitialState({
  loaded: false
});

export interface Order {
  id: number;
  title: string;
  total: number;
  clearanceType: number;
  createdAt: Date;
  updatedAt: Date;
  supplier?: any;
  importer?: any;
}

export interface State {
  newOrder: {
    inSaving: boolean,
    saved: boolean,
    errors: any[]
  };
  list: OrdersState;
}

export const initialState: State = {
  newOrder: {
    inSaving: false,
    saved: false,
    errors: null
  },
  list: ordersInitialState
};


export const reducer = createReducer(
  initialState,
  on(OrdersActions.InitNewOrder, (state) => initialState),
  on(OrdersActions.createNewOrderFailed, (state, action) => ({
    ...state,
    newOrder: {...state.newOrder, inSaving: false, saved: false, errors: action.errors}
  })),
  on(OrdersActions.createNewOrder, (state) => ({...state, newOrder: {...state.newOrder, inSaving: true, errors: null}})),
  on(OrdersActions.createNewOrderSuccess, (state, action) => ({
    ...state,
    newOrder: {...state.newOrder, inSaving: false, error: null, saved: true},
    list: orderAdapter.upsertOne(action.order, state.list)
  })),
  on(OrdersActions.GetPreviousOrdersSuccess, (state, action) => ({
    ...state,
    list: orderAdapter.upsertMany(action.orders, {...state.list, loaded: true})
  })),
  on(OrdersActions.GetSingleOrderSuccess, (state, action) => ({
    ...state,
    list: orderAdapter.upsertOne(action.order, {...state.list})
  })),
  on(OrdersActions.loadOrderss, state => state),
  )
;

